import { useQuery } from '@tanstack/react-query'

import type { InsuranceEstimateResponse } from '../../types/booking.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export const useEstimateMyBookingInsuranceQuery = (
  bookingId: string | undefined,
  enabled = true
) => {
  return useQuery({
    enabled: !!bookingId && enabled,
    queryFn: async () => {
      const response = await apiClient.client.post<InsuranceEstimateResponse>(
        `/me/bookings/${bookingId}/insurance/estimate`
      )
      return response.data
    },
    queryKey: [...meKeys.me, 'bookings', bookingId, 'insurance-estimate'] as const,
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}
